/*

Author: David Biga - All rights reserved - 2015

Description:  This is the core file that handles our gui interface and interacting with all of our objs
*/
import { server } from '../../engine/server'
import {buildings} from '../../../core/controllers/Buildings'
import {spaces} from '../../../core/controllers/Spaces'
import {sensors} from '../../../core/controllers/Sensors'

import {levelRenderer} from './LevelRenderer';

import THREE from 'particlespace-graphics-engine'
import THREEx from 'particlespace-graphics-engine-extensions'
import {browserHistory} from 'react-router';

var LevelHandler = Class.create({
	context: null,
	buildingData: null,
	buildingID: 0,
  	initialize: function() {
	},
	init: function(context) {
		/*
		Store data retrieved from reactjs context
		*/
		this.buildingData = {
			"buildingData": context.state.data.belongsTo,
			"buildingDetails": context.state.data.data,
			"buildingMetaData": context.state.data.meta_data,
			"buildingID": context.state.buildingID,
			"levelID": context.state.levelID
		}

		// set context for use on updating state
		this.context = context;
		// #  Create local variables
		// setup local vars
		var changeView,roomChange,toolbar,tools,notifications,
		// #  Starts our graphical system
		// update naming convention
		canvas = levelRenderer.init(this);
		// #  Start our cube popup object
		//spaceOverViewModal = new spaceOverViewObj(routingObject);
		//get our doms
		changeView = document.getElementById("perspective");
		roomChange = document.getElementsByClassName("changeRoomType");
		var toolbox = document.getElementsByClassName("toolbox");
		var informationBox = document.getElementsByClassName("informationbox");
		var informationBoxHandleBarsCont = "information-handlebars";
		var informationBoxHandleBarsTemplate = "informationBox-handlebartemplate";
		tools = document.getElementsByClassName("tools");
		notifications = document.getElementsByClassName("notification_on_screen");
		// #  Assign our variables locally
		this.changeView = changeView;
		this.roomChange = roomChange;
		this.toolbox = toolbox;
		this.informationBox = informationBox;
		this.informationBoxHandleBarsCont = informationBoxHandleBarsCont;
		this.informationBoxHandleBarsTemplate = informationBoxHandleBarsTemplate;
		this.tools = tools;
		this.canvas = canvas;
		this.notifications = notifications;
  		// #  Set our spaceOverView object
  		//this.spaceOverViewModal = spaceOverViewModal;
		// #  Setup our GUI listeners
		//this.initActionListeners();
		// #  Setup SlimScroll
		//this.setupSlimScroll();
		// #  Setup draggables
		this.setupDraggable(this.toolbox);
		this.setupDraggable(this.informationBox);
		// #  Load all data associated with the active floor
  		this.loadFloorData();
		// #  Setup tooltips
		this.setupToolTips(this.notifications);
		// #  Setup tooltips
		this.setupToolTips(this.informationBox);
		// #  Trigger LevelRenderer to init listeners
		levelRenderer.initActionListeners();
	},
	/*
		Passes object containing state updates for corresponding context/component
	*/
	updateState: function(obj) {
		this.context.setState(obj);
	},
	reloadSpace: function(uuid, colorHex) {
		levelRenderer.reloadSpace(uuid, colorHex);
	},
	loadSpaceOverView: function(obj) {
		spaces.getSpace(obj.uuid, this.context, this);
	},
	loadSensorOverview: function(obj) {
		sensors.getSensor(obj.uuid, this.context, this);
	},
	loadFloorData: function() {
		buildings.getBuildingLevelData(this.context, function(spaces) {
			if(spaces === undefined){ return; }
			levelRenderer.populateSpaces(spaces.data.spaces);
		});
	},
	removeOldListeners: function() {
		// #  Remove any previous action listeners
		this.changeView.removeEventListener('click', this.initChangeView.bind(this), false );
		// WHEN DEALING WITH CLASS YOU NEED TO LOOP THROUGH THE ARRAY RETURNED WITH GETELEMENTSBYCLASSNAME
		for(var i=0;i<this.roomChange.length;i++){
			this.roomChange[i].removeEventListener( 'click', this.initChangeRoom.bind(this), false );
   		}
		// #  Hook up action listener for toolbox edit mode
		for(var i=0;i<this.toolbox.length;i++){
			this.toolbox[i].removeEventListener('click',this.initToolBoxClick.bind(this),false);
   		}
		// #  We need to setup a mouseover event on our toolbox to fix issue with canvas adding object
		this.toolbox[0].removeEventListener('mouseover',this.disableEditMode.bind(this),false);
		this.toolbox[0].removeEventListener('mouseout',this.enableEditMode.bind(this),false);
		// #  Hook up action listener for notifications
		for(var i=0;i<this.notifications.length;i++){
			this.notifications[i].removeEventListener('click',this.initNotificationsClick.bind(this),false);
   		}
   		// #  Setup our go back button
   		jQuery(jQuery(".notification_on_screen")).find(".go-back").unbind('click');

	},
	initActionListeners: function() {
		// #  Unbind old listeners
		this.removeOldListeners();

		// container listeners
		this.changeView.addEventListener( 'click', this.initChangeView.bind(this), false );
		// WHEN DEALING WITH CLASS YOU NEED TO LOOP THROUGH THE ARRAY RETURNED WITH GETELEMENTSBYCLASSNAME
		for(var i=0;i<this.roomChange.length;i++){
			this.roomChange[i].addEventListener( 'click', this.initChangeRoom.bind(this), false );
   		}
		// #  Hook up action listener for toolbox edit mode
		for(var i=0;i<this.toolbox.length;i++){
			this.toolbox[i].addEventListener('click',this.initToolBoxClick.bind(this),false);
   		}
		// #  We need to setup a mouseover event on our toolbox to fix issue with canvas adding object
		this.toolbox[0].addEventListener('mouseover',this.disableEditMode.bind(this),false);
		this.toolbox[0].addEventListener('mouseout',this.enableEditMode.bind(this),false);
		// #  Hook up action listener for notifications
		for(var i=0;i<this.notifications.length;i++){
			this.notifications[i].addEventListener('click',this.initNotificationsClick.bind(this),false);
   		}
   		// #  Setup our go back button
   		jQuery(jQuery(".notification_on_screen")).find(".go-back").on('click',this.goBack.bind(this));

	},
	initChangeView: function(event)
	{
		this.canvas.updatePerspectiveCamera(this.changeView);
	},
	initChangeRoom: function(event)
	{
		jQuery(".changeRoomType.active").removeClass('active');
		jQuery(event.path[1]).toggleClass('active');
		this.canvas.room.updateRoomType(event.path[1].id);
	},
	initToolBoxClick: function(event)
	{
		event.preventDefault();
		// #  Handle all functions related to and for edit mode enabled.
		if(jQuery(event.srcElement).hasClass('editmode'))
		{
			jQuery(event.srcElement).toggleClass('active');	
			jQuery(".tooltip_custom.editmodeNotification").toggleClass('active');
			if(jQuery(".editmodeNotification").hasClass('active'))
			{
				jQuery(".editmode_tooltip").attr('data-original-title','Warning!  You are now in edit mode.');
				// #  Set our edit mode to true
				this.canvas.editMode = true;
				// #  Close spaceOverview
				if(this.spaceOverViewModal.spaceOverViewActive)
				{
					this.spaceOverViewModal.closeSpaceOverView();
					this.spaceOverViewModal.hideSpaceOverView();
					this.canvas.clearColors();
				}
				// #  Disables Free Roam by default
				this.disableFreeRoam();
			}
			else
			{	
				jQuery(".editmode_tooltip").attr('data-original-title','Edit Mode has been disabled.');
				// #  Set our edit mode to false
				this.canvas.editMode = false;
				// #  Close spaceOverview
				this.spaceOverViewModal.showSpaceOverView();
				this.canvas.checkSpaceOverViewActive();
				// #  Enabled free roam on default
				this.enableFreeRoam();
				// #  Clear our grid of any tmp objects
				this.canvas.clearTmpHover();
			}
			// #  Display our tooltip
			jQuery(".editmode_tooltip").tooltip('show');
			// #  Set 2 second timer to than hide it
			setTimeout(function(){
				jQuery(".editmode_tooltip").tooltip('hide');
			}, 2000);
			// #  Toggle our tool bar based on if we are in edit mode or not
			this.showHideTools();
		}
		else if(jQuery(event.srcElement).hasClass('freeroam_button'))
		{
			jQuery(event.srcElement).toggleClass('active');	
			jQuery(".tooltip_custom.freeroam").toggleClass('disabled');
			if(jQuery(".freeroam").hasClass('disabled'))
			{
				jQuery(".freeroam_tooltip").attr('data-original-title','Free Roam is disabled.');
				// #  Set our LOrbital controls to false
				this.canvas.controls.enabled = false;
			}
			else
			{					
				jQuery(".freeroam_tooltip").attr('data-original-title','Free Roam is enabled.');
				// #  Set our Orbital controls to true
				this.canvas.controls.enabled = true;
			}
			// #  Display our tooltip
			jQuery(".freeroam_tooltip").tooltip('show');
			// #  Set 2 second timer to than hide it
			setTimeout(function(){
				jQuery(".freeroam_tooltip").tooltip('hide');
			}, 2000);
		}
		// #  This section handles all zoom and rotation.
		else if(jQuery(event.srcElement).hasClass('zoom-in')) {
			this.canvas.zoomIn(event);
		}
		else if(jQuery(event.srcElement).hasClass('zoom-out')) {
			this.canvas.zoomOut(event);
		}
		else if(jQuery(event.srcElement).hasClass('rotate-right')) {
			this.canvas.rotateRight(event);
		}
		else if(jQuery(event.srcElement).hasClass('rotate-left')) {
			this.canvas.rotateLeft(event);
		}
		
		
	},
	// #  Handles all notifications events
	initNotificationsClick: function(event)
	{
		event.preventDefault();
		// #  DEPRECATEED
		/*if(jQuery(event.srcElement).hasClass('fa-arrows'))
		{
			
			jQuery(".tooltip_custom.freeroam").toggleClass('disabled');
			if(jQuery(".freeroam").hasClass('disabled'))
			{
				jQuery(".freeroam_tooltip").attr('data-original-title','Free Roam is disabled.');
				// #  Set our LOrbital controls to false
				this.canvas.controls.enabled = false;
			}
			else
			{	
				jQuery(".freeroam_tooltip").attr('data-original-title','Free Roam is enabled.');
				// #  Set our Orbital controls to true
				this.canvas.controls.enabled = true;
			
			}
		}	*/
	},
	// #  Toggles our toolbar based on if edit mode is enabled or not.
	showHideTools: function() {
		jQuery(this.tools).toggle('drop');
	},
	disableEditMode: function(event) {
		// #  Confirm edit mode is actually in session
		if(this.canvas.editMode == true && jQuery(".editmodeNotification").hasClass('active'))
		{
			this.canvas.editMode = false;
		}
	},
	enableEditMode: function(event) {
		// #  Confirm edit mode is actually in session
		if(this.canvas.editMode == false && jQuery(".editmodeNotification").hasClass('active'))
			this.canvas.editMode = true;
	},
	disableFreeRoam: function() {
		
		// #  Do some verifying
		if(jQuery(".freeroam_button").hasClass('active'))
		{
			jQuery(".freeroam_button").toggleClass('active');
			jQuery(".tooltip_custom.freeroam").toggleClass('disabled');
			
			jQuery(".freeroam_tooltip").attr('data-original-title','Free Roam is disabled.');
			// #  Set our LOrbital controls to false
			this.canvas.controls.enabled = false;
		}
		
	},
	enableFreeRoam: function() {
		// #  Do some verifying
		if(!jQuery(".freeroam_button").hasClass('active'))
		{
			jQuery(".freeroam_button").toggleClass('active');
			jQuery(".tooltip_custom.freeroam").toggleClass('disabled');
			
			jQuery(".freeroam_tooltip").attr('data-original-title','Free Roam is enabled.');
			// #  Set our Orbital controls to true
			this.canvas.controls.enabled = true;
		}
		
	},
	setupSlimScroll: function() {
		// #  We need to setup our slimScroll on our editing window
		jQuery(jQuery(this.tools).find('.scroll-attach')).slimScroll({
        	height: '450px',
			width: '130px',
			alwaysVisible: true
		});
	},
	setupDraggable: function(element) {
		// #  Enable draggables
		jQuery(element).draggable();	
	},
	setupToolTips: function(element) {

		// #  Enable tooltips
		jQuery(jQuery(element).find(".tooltip_custom")).hover(function() {
				jQuery(this).find('[data-toggle="tooltip"]').tooltip('show');
			}, function() {
				jQuery(this).find('[data-toggle="tooltip"]').tooltip('hide');
			}
		);
	},
	stopWindowTimeouts: function() {
		levelRenderer.clearWindowTimeouts();
	},
	// #  Go back to our building overview
	goBack: function(event) {
		// #  Empties our active floor data
		this.routingObject.userObject.emptyActiveFloor();
		// #  Clears our intervals
		this.checkClearInterval();
		// # Move to building overview
		this.routingObject.buildingOverviewAssets(this.routingObject.userObject.activeBuilding.buildingID);
	},
	// #  We use this function to show the last time this object was updated
	lastUpdated: function() {
		var self = this;
		if(typeof self.routingObject.userObject.activeFloor.last_updated === "undefined"){
			jQuery(".last_updated span").html("Empty Floor, lets add something!"); 
			return;
		}
		// #  Make update
		jQuery(".last_updated span").html(self.timeSince(new Date(self.routingObject.userObject.activeFloor.last_updated)));
		self.updateInterval = setInterval(function()
		{
			// #  Check to see if we still have an active floor.
			self.checkClearInterval();
			// #  Update our timer
			jQuery(".last_updated span").html(self.timeSince(new Date(self.routingObject.userObject.activeFloor.last_updated)));
		}, 10000);
	},
	// #  Manually updates the new time right when server returns
	manualLastUpdate: function() {
		var self = this;
		jQuery(".last_updated span").html(self.timeSince(new Date(self.routingObject.userObject.activeFloor.last_updated)));

	},
	// #  Use this function to check if we still have an active floor/if not clear interval
	checkClearInterval: function() {
		if(this.routingObject.userObject.activeFloor == null)
		{
			clearInterval(this.updateInterval);
			// #  Clear any data
			jQuery(".last_updated span").empty();
		}
	},
	// #  Timer function
	timeSince: function(date) {
		if (typeof date !== 'object') {
	        date = new Date(date);
	    }

	    var seconds = Math.floor((new Date() - date) / 1000);
	    var intervalType;

	    var interval = Math.floor(seconds / 31536000);
	    if (interval >= 1) {
	        intervalType = 'year';
	    } else {
	        interval = Math.floor(seconds / 2592000);
	        if (interval >= 1) {
	            intervalType = 'month';
	        } else {
	            interval = Math.floor(seconds / 86400);
	            if (interval >= 1) {
	                intervalType = 'day';
	            } else {
	                interval = Math.floor(seconds / 3600);
	                if (interval >= 1) {
	                    intervalType = "hour";
	                } else {
	                    interval = Math.floor(seconds / 60);
	                    if (interval >= 1) {
	                        intervalType = "minute";
	                    } else {
	                        //interval = seconds;
	                        interval = "";
	                        intervalType = "less than a minute";
	                    }
	                }
	            }
	        }
	    }

	    if (interval > 1 || interval === 0) {
	    	if(intervalType == "less than a minute")
	    	{

	    	}
	    	else
	    	{
	        	intervalType += 's';
	        }
	    }

	    return "last updated: " + interval + ' ' + intervalType + " ago";
	}
});

export let levelHandler = new LevelHandler();


// WEBPACK FOOTER //
// app/core/graphic_engine/controllers/LevelHandler.js